<template>
  <el-container  style="display: block;">
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <el-row :span="2" style="margin-top: 30px;">
          设备品牌:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          设备型号:<el-input v-model="xinghao" style="width: 150px;" placeholder="请输入刷新时间"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          运存:<el-input v-model="yuncun" style="width: 150px;" placeholder="请输入层级"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          处理器:<el-input v-model="chuliqi" style="width: 150px;" placeholder="请输入位移"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          分辨率:<el-input v-model="fenbianlv" style="width: 150px;" placeholder="请输入透视"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          悬浮兔自推个数:<el-input v-model="xuanfutu" style="width: 150px;" placeholder="请输入个数"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          尺寸比例:<el-input v-model="chicunbili" style="width: 150px;" placeholder="请输入比例"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          T1统一比列:<el-input v-model="T1" style="width: 150px;" placeholder="请输入比例"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          元素点上限:<el-input v-model="yuansushangxian" style="width: 150px;" placeholder="请输入元素点上限"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
          备注:<el-input v-model="beizhu" style="width: 150px;" placeholder="请输入备注"></el-input>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              通用倍数:<el-input v-model="tongyong" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              通用上限:<el-input v-model="tongyongs" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              精准倍数:<el-input v-model="jingzhun" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              精准上限:<el-input v-model="jingzhuns" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              内部倍数:<el-input v-model="neibu" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              内部上限:<el-input v-model="neibus" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              标识倍数:<el-input v-model="biaoshi" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              标识上限:<el-input v-model="biaoshis" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              一般倍数:<el-input v-model="yiban" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              一般上限:<el-input v-model="yibans" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              地区倍数:<el-input v-model="diqu" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              地区上限:<el-input v-model="diqus" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;">
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              点线(坐标)倍数:<el-input v-model="dianxianzb" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              点线(坐标)上限:<el-input v-model="dianxianzbs" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              点线(设备)倍数:<el-input v-model="dianxiansb" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              点线(设备)上限:<el-input v-model="dianxiansbs" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              突发倍数:<el-input v-model="tufa" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              突发上限:<el-input v-model="tufas" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              指向倍数:<el-input v-model="yuansubeishu" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              指向上限:<el-input v-model="yuansubeishus" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              连接倍数:<el-input v-model="lxbeishu" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              连接上限:<el-input v-model="lxbeishus" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row :span="2" style="margin-top: 30px;">
              飞行倍数:<el-input v-model="fxbeishu" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
          <el-row :span="2" style="margin-top: 30px;">
              飞行上限:<el-input v-model="fxbeishus" style="width: 150px;" placeholder="请输入"></el-input>
          </el-row>
        </el-col>
      </el-row>

      <el-row :span="2" style="margin-top: 30px;">
          <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
      </el-row>



     <!-- <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
          <el-button round :class="{'pai':pait==1}" @click="pai(1)">开关排序</el-button>
          <el-button round :class="{'pai':pait==2}" @click="pai(2)">时间排序</el-button>
      </el-row> -->
    </el-row>
    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        :cell-class-name="addclass"
        height="1500"
        max-height="850"
        width='2780'
      	border
      	style="width: 2780px;height: 800px;text-align: center;margin: 0;">
        <el-table-column

          width="100"
          label="开关"
           >
           <template slot-scope="scope">
                <div style="color: greenyellow;"  @click="kg(2,scope.row.id)" v-if="scope.row.status == 1">开</div>
                <div style="color: red;"  @click="kg(1,scope.row.id)" v-if="scope.row.status == 2">关</div>
                <div   @click="dell(scope.row.id)">删除</div>
                <div style="color: red;"  @click="copy(scope.row.id)">复制</div>
           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="名字"
           >
           <template slot-scope="scope">
               <div  @click="changeT(39,scope.row.gname,scope.row.id)">{{scope.row.gname}}</div>



           </template>
        </el-table-column>
      	<el-table-column
          width="200"
      	  label="设备品牌"
      	   >
           <template slot-scope="scope">
               <div  @click="changeT(1,scope.row.name,scope.row.id)">{{scope.row.name}}</div>



           </template>
      	</el-table-column>
        <el-table-column
          width="200"
          label="备注"
           >
           <template slot-scope="scope">
               <div  @click="changeT(8,scope.row.beizhu,scope.row.id)">{{scope.row.beizhu}}</div>



           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="设备型号"
           >
           <template slot-scope="scope">
               <div  @click="changeT(2,scope.row.xinghao,scope.row.id)">{{scope.row.xinghao}}</div>


           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="设备ID"
           >
           <template slot-scope="scope">
               <div  @click="changeT(36,scope.row.shebeiid,scope.row.id)">{{scope.row.shebeiid}}</div>


           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="运存"
           >
           <template slot-scope="scope">
               <div  @click="changeT(3,scope.row.yuncun,scope.row.id)">{{scope.row.yuncun}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="处理器"
           >
           <template slot-scope="scope">
               <div  @click="changeT(4,scope.row.chuliqi,scope.row.id)">{{scope.row.chuliqi}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="分辨率"
           >
           <template slot-scope="scope">
               <div  @click="changeT(5,scope.row.fenbianlv,scope.row.id)">{{scope.row.fenbianlv}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="悬浮兔自推个数"
           >
           <template slot-scope="scope">
               <div  @click="changeT(38,scope.row.xuanfutu,scope.row.id)">{{scope.row.xuanfutu}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="元素点上限"
          style="font-weight:bold;"
           >
           <template slot-scope="scope">
               <div  @click="changeT(14,scope.row.yuansushangxian,scope.row.id)">{{scope.row.yuansushangxian}}</div>

           </template>
        </el-table-column>
        <!-- <el-table-column
          width="80"
          label="生活倍数"
           >
           <template slot-scope="scope">
               <div  @click="changeT(9,scope.row.shbeishu,scope.row.id)">{{scope.row.shbeishu}}</div>


           </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="生活统一刷新时间"
           >
           <template slot-scope="scope">
               <div  @click="changeT(12,scope.row.shtime,scope.row.id)">{{scope.row.shtime}}</div>


           </template>
        </el-table-column> -->
        <el-table-column label="通用" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(18,scope.row.tongyong,scope.row.id)">{{scope.row.tongyong}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(19,scope.row.tongyongs,scope.row.id)">{{scope.row.tongyongs}}</div>
             </template>
          </el-table-column>
         </el-table-column>
         <el-table-column label="精准" style="text-align: center;">
           <el-table-column
             width="50"
             label="倍数"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(20,scope.row.jingzhun,scope.row.id)">{{scope.row.jingzhun}}</div>
              </template>
           </el-table-column>
           <el-table-column
             width="50"
             label="上限"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(21,scope.row.jingzhuns,scope.row.id)">{{scope.row.jingzhuns}}</div>
              </template>
           </el-table-column>
          </el-table-column>
          <el-table-column label="内部" style="text-align: center;">
            <el-table-column
              width="50"
              label="倍数"
               >
               <template slot-scope="scope">
                   <div  @click="changeT(22,scope.row.neibu,scope.row.id)">{{scope.row.neibu}}</div>
               </template>
            </el-table-column>
            <el-table-column
              width="50"
              label="上限"
               >
               <template slot-scope="scope">
                   <div  @click="changeT(23,scope.row.neibus,scope.row.id)">{{scope.row.neibus}}</div>
               </template>
            </el-table-column>
           </el-table-column>
        <el-table-column label="标识" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(24,scope.row.biaoshi,scope.row.id)">{{scope.row.biaoshi}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(25,scope.row.biaoshis,scope.row.id)">{{scope.row.biaoshis}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="一般" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(26,scope.row.yiban,scope.row.id)">{{scope.row.yiban}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(27,scope.row.yibans,scope.row.id)">{{scope.row.yibans}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="地区" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(28,scope.row.diqu,scope.row.id)">{{scope.row.diqu}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(29,scope.row.diqus,scope.row.id)">{{scope.row.diqus}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="点线(坐标)" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(30,scope.row.dianxianzb,scope.row.id)">{{scope.row.dianxianzb}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(31,scope.row.dianxianzbs,scope.row.id)">{{scope.row.dianxianzbs}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="点线(设备)" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(32,scope.row.dianxiansb,scope.row.id)">{{scope.row.dianxiansb}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(33,scope.row.dianxiansbs,scope.row.id)">{{scope.row.dianxiansbs}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="突发" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(34,scope.row.tufa,scope.row.id)">{{scope.row.tufa}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(35,scope.row.tufas,scope.row.id)">{{scope.row.tufas}}</div>
             </template>
          </el-table-column>
         </el-table-column>
        <el-table-column label="指向" style="text-align: center;">
          <el-table-column
            width="50"
            label="倍数"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(6,scope.row.yuansubeishu,scope.row.id)">{{scope.row.yuansubeishu}}</div>
             </template>
          </el-table-column>
          <el-table-column
            width="50"
            label="上限"
             >
             <template slot-scope="scope">
                 <div  @click="changeT(15,scope.row.yuansubeishus,scope.row.id)">{{scope.row.yuansubeishus}}</div>
             </template>
          </el-table-column>
         </el-table-column>
         <el-table-column

          label="连接"
           >
           <el-table-column
             width="50"
             label="倍数"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(10,scope.row.lxbeishu,scope.row.id)">{{scope.row.lxbeishu}}</div>


              </template>
           </el-table-column>
           <el-table-column
             width="50"
             label="上限"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(16,scope.row.lxbeishus,scope.row.id)">{{scope.row.lxbeishus}}</div>


              </template>
           </el-table-column>

        </el-table-column>
        <el-table-column

          label="飞行"
           >
           <el-table-column
             width="50"
             label="倍数"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(11,scope.row.fxbeishu,scope.row.id)">{{scope.row.fxbeishu}}</div>


              </template>
           </el-table-column>
           <el-table-column
             width="50"
             label="上限"
              >
              <template slot-scope="scope">
                  <div  @click="changeT(17,scope.row.fxbeishus,scope.row.id)">{{scope.row.fxbeishus}}</div>


              </template>
           </el-table-column>

        </el-table-column>
        <el-table-column
          width="100"
          label="尺寸比例"
           >
           <template slot-scope="scope">
               <div  @click="changeT(7,scope.row.chicunbili,scope.row.id)">{{scope.row.chicunbili}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="T1统一比例"
           >
           <template slot-scope="scope">
               <div  @click="changeT(13,scope.row.T1,scope.row.id)">{{scope.row.T1}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="地图"
           >
           <template slot-scope="scope">
               <div  @click="changekg(1,scope.row.ditukg,scope.row.id)">{{scope.row.ditukg}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="地图(待机)"
           >
           <template slot-scope="scope">
               <div  @click="changekg(11,scope.row.ditudaijig,scope.row.id)">{{scope.row.ditudaijig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="地图(其他)"
           >
           <template slot-scope="scope">
               <div  @click="changekg(12,scope.row.dituqitag,scope.row.id)">{{scope.row.dituqitag}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="多维元素"
           >
           <template slot-scope="scope">
               <div  @click="changekg(2,scope.row.duoweikg,scope.row.id)">{{scope.row.duoweikg}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="多维元素(待机)"
           >
           <template slot-scope="scope">
               <div  @click="changekg(13,scope.row.duoweidaijig,scope.row.id)">{{scope.row.duoweidaijig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="多维元素(其他)"
           >
           <template slot-scope="scope">
               <div  @click="changekg(14,scope.row.duoweiqitag,scope.row.id)">{{scope.row.duoweiqitag}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="蓝色粒子层（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(3,scope.row.lanselizikg,scope.row.id)">{{scope.row.lanselizikg}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="蓝色粒子层（其他）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(6,scope.row.xingkonglizig,scope.row.id)">{{scope.row.xingkonglizig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="随机推荐（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(4,scope.row.suijituijiankg,scope.row.id)">{{scope.row.suijituijiankg}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="实时推荐（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(5,scope.row.shishituijiankg,scope.row.id)">{{scope.row.shishituijiankg}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="日月开关"
           >
           <template slot-scope="scope">
               <div  @click="changekg(18,scope.row.riyue,scope.row.id)">{{scope.row.riyue}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="实时推荐左下（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(15,scope.row.shishizuoxiadaijig,scope.row.id)">{{scope.row.shishizuoxiadaijig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="实时推荐上方（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(16,scope.row.shishishangdaijig,scope.row.id)">{{scope.row.shishishangdaijig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="实时推荐上方（其他）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(17,scope.row.shishishangqitag,scope.row.id)">{{scope.row.shishishangqitag}}</div>

           </template>
        </el-table-column>

        <el-table-column
          width="100"
          label="兔子组（待机）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(7,scope.row.tuzizudaijig,scope.row.id)">{{scope.row.tuzizudaijig}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="兔子组（其他）"
           >
           <template slot-scope="scope">
               <div  @click="changekg(8,scope.row.tuzizuqita,scope.row.id)">{{scope.row.tuzizuqita}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="地球开关"
           >
           <template slot-scope="scope">
               <div  @click="changekg(9,scope.row.diqiug,scope.row.id)">{{scope.row.diqiug}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="语言"
           >
           <template slot-scope="scope">
               <div  @click="changezh(scope.row.zh,scope.row.id)">{{scope.row.zh}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="发音人"
           >
           <template slot-scope="scope">
               <div  @click="changefy(scope.row.fayinxuanze,scope.row.id)">{{scope.row.fayinxuanze}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="语速"
           >
           <template slot-scope="scope">
               <div  @click="changeT(37,scope.row.yusu,scope.row.id)">{{scope.row.yusu}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="监听框"
           >
           <template slot-scope="scope">
               <div  @click="changeT(41,scope.row.kstatus,scope.row.id)">{{scope.row.kstatus}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="前端桌面"
           >
           <template slot-scope="scope">
               <div  @click="changeT(42,scope.row.zstatus,scope.row.id)">{{scope.row.zstatus}}</div>

           </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="移动"
           >
           <el-table-column
             width="50"
             label="实验"
              >
              <template slot-scope="scope">
                  <div  @click="moveT(1,scope.row.id)">实验</div>


              </template>
           </el-table-column>
           <el-table-column
             width="50"
             label="场景"
              >
              <template slot-scope="scope">
                  <div  @click="moveT(2,scope.row.id)">场景</div>


              </template>
           </el-table-column>
        </el-table-column>
        </el-table>
      </template>
      <!-- <div class="page">
      	<el-pagination
      	  @size-change="loadData()"
      	  @current-change="loadData()"
      	  :current-page.sync="page"
      	  :page-size="20"
      	  background
      	  layout="total,prev, pager, next, jumper"
      	  :total="count">
      	</el-pagination>
      </div> -->
    </el-row>

    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改发音人"
      :visible.sync="fashengxuanze"
      width="30%"
      center>
      <el-select v-model="fayin"   filterable placeholder="请选择" >
          <el-option
            v-for="item in baoshanArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="fashengxuanze = false">取 消</el-button>
    	<el-button type="primary" @click="dochangefayin()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改语言"
      :visible.sync="zhxuanze"
      width="30%"
      center>
      <el-select v-model="zh"   filterable placeholder="请选择" >
          <el-option
            v-for="item in zhArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="zhxuanze = false">取 消</el-button>
    	<el-button type="primary" @click="dochangezh()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         zhArr:[],
         dialogVisibled:false,
         baoshanArr:[],
         fayin:'M',
         fashengxuanze:false,
         centerDialogVisible:false,
         changes:'',
         tableData:[],
         t:0,
         c_id:0,
         name:'0',
         xinghao:'0',
         yuncun:'0',
         chuliqi:'0',
         fenbianlv:'0',
         chicunbili:'M',
         'beizhu':'备注',
         'T1':'M',
         'yuansubeishus':'M',
         'tongyong':'M',
         'tongyongs':'M',
         'jingzhun':'M',
         'jingzhuns':'M',
         'neibu':'M',
         'neibus':'M',
         'biaoshi':'M',
         'biaoshis':'M',
         'yiban':'M',
         'yibans':'M',
         'diqu':'M',
         'diqus':'M',
         'dianxiansb':'M',
         'dianxiansbs':'M',
         'dianxianzb':'M',
         'dianxianzbs':'M',
         'tufa':'M',
         'tufas':'M',
         'yuansushangxian':'M',
         'yuansubeishu':'M',
         'lxbeishu':'M',
         'lxbeishus':'M',
         'fxbeishu':'M',
         'fxbeishus':'M',
         'xuanfutu':'M',
         'fyId':0,
         'dellId':0,
         'zhId':0,
         'zh':'中文',
         'zhxuanze':false,

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.getFayin();
      this.loadData();
      this.loadDatazh();
    },

	methods:{
    getFayin(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/fayinrenCheck'
      })
      .then(res=>{
          this.baoshanArr = res.data.data

      })
      .catch(err=>{

      });
    },
    moveT(scw,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          scw:scw
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentMove'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '移动成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    copy(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentCopy'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '复制成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    dell(id){
      this.dellId = id
      this.dialogVisibled = true
    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.dellId,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentDell'
      })
      .then(res=>{
         this.loadData()
         this.dialogVisibled = false
      })
      .catch(err=>{

      });
    },
    changezh(zh,id){
      this.zhId = id
      this.zh = zh
      this.zhxuanze = true
    },
    changefy(fayin,id){
      this.fyId = id
      this.fayin = fayin
      this.fashengxuanze = true
    },
    dochangefayin(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.fyId,
          name:this.fayin
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentChangefy'
      })
      .then(res=>{
         this.loadData()
         this.fashengxuanze = false
      })
      .catch(err=>{

      });
    },
    dochangezh(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.zhId,
          name:this.zh
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentChangezh'
      })
      .then(res=>{
         this.loadData()
         this.zhxuanze = false
      })
      .catch(err=>{

      });
    },
    addclass(row){

      if (row.columnIndex==7) {
          return 'yuansushangxian'

      }

    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    changekg(t,type,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          t:t,
          type:type
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentChangekg'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentChange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    kg(p,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          p:p,
          t:1
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/statusChangequ'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    add(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          xinghao:this.xinghao,
          yuncun:this.yuncun,
          chuliqi:this.chuliqi,
          fenbianlv:this.fenbianlv,
          chicunbili:this.chicunbili,
          beizhu:this.beizhu,
          T1:this.T1,
          yuansushangxian:this.yuansushangxian,
          tongyong:this.tongyong,
          tongyongs:this.tongyongs,
          jingzhun:this.jingzhun,
          jingzhuns:this.jingzhuns,
          neibu:this.neibu,
          neibus:this.neibus,
          biaoshi:this.biaoshi,
          biaoshis:this.biaoshis,
          yiban:this.yiban,
          yibans:this.yibans,
          diqu:this.diqu,
          diqus:this.diqus,
          dianxiansb:this.dianxiansb,
          dianxiansbs:this.dianxiansbs,
          dianxianzb:this.dianxianzb,
          dianxianzbs:this.dianxianzbs,
          tufa:this.tufa,
          tufas:this.tufas,
          yuansubeishu:this.yuansubeishu,
          yuansubeishus:this.yuansubeishus,
          lxbeishu:this.lxbeishu,
          lxbeishus:this.lxbeishus,
          fxbeishu:this.fxbeishu,
          fxbeishus:this.fxbeishus,
          xuanfutu:this.xuanfutu,
          scw:3,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/equipmentAdd'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:3,
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/equipmentList'
    	})
    	.then(res=>{
    		this.tableData = res.data;


    	})
    	.catch(err=>{

    	});
    },
    loadDatazh(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:1,
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/equipmentListzh'
    	})
    	.then(res=>{
    		this.zhArr = res.data;


    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
  .yuansushangxian{
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/equipmentw.vue